import React, { Component } from 'react';
import { AddGroupProps, AddGroupState } from '../../interfaces/group'
import { connect } from 'react-redux'
import jwt from 'jsonwebtoken'
import Topbar from '../topbar/topbar'
import Sidebar from '../sidebar/sidebar'
import Footer from '../footer/footer'
import { Link, Redirect } from 'react-router-dom';
import { storesList, addGroupStore } from '../../redux/actions/groupStore';
import Select from 'react-select'
import CheckChanges from '../confirmOnLeave';
import config from '../config/setting';
import { companyList } from '../../redux/actions/company';
import { logoutUser } from '../../redux/actions/user';


class AddGroup extends Component<AddGroupProps, AddGroupState> {
    constructor(props: any) {
        super(props);
        this.state = {
            name: "",
            description: "",
            store: [],
            company: [],
            territary: '0',
            user: "",
            status: '1',
        }
        this.handleSaveBtnClick = this.handleSaveBtnClick.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }
    componentDidMount() {
        this.props.companyList();
    }
    handleInputChange(event: { target: { name: any; value: any; }; }) {
        if(event.target.value[0]==" "){
        }else{
          this.setState({
              [event.target.name]: event.target.value,
          });
        }
    }

    handleItemsInputChange = (e: any) => {
        let array: any = [];
        e &&
            e.map((obj: any) => {
                array.push(obj.value)
            })
        this.setState({ store: array })
    };

    handleCompanyInputChange = (e: any) => {
        if (e && e.value > 0) {
            this.setState({ company: e.value });
        } else {
            this.setState({ company: " " });
        }

        this.props.storesList(e.value);
    };

    isGroupReady = () => {
        const { name, store, territary, status, company, description } = this.state
        return (name !== "" && store.length > 0 && territary !== "" && company !== "" && description !== "" && status !== "");
    }

    handleSaveBtnClick = (event: any) => {
        let { name, description, store, user, company, territary, status } = this.state;

        let data = {
            name: name,
            description: description,
            store: store,
            territary: territary,
            status: status,
            user_id: user,
            company: company,
            isActive: config.ACTIVE
        }
        this.props.addGroup(data);
    }

    setStore = (storeId: any) => {
        this.setState({ store: storeId })
    }
    render() {
        if (sessionStorage.token) {
            jwt.verify(sessionStorage.token, config.secretKey, (err: any, decoded: any) => {
                if (err) {
                    this.props.logoutUser();
                }
            });
        } else {
            return <Redirect to="/" />
        }
        let msg;
        let messcolor;
        const { isInserted, message } = this.props;
        const stores = this.props.stores || [];
        const companies = this.props.companies || [];

        let storeData: any = [];
        stores.forEach((element: any) => {
            const store = { label: element.name, value: element.id };
            storeData.push(store);
        });

        let companyData: any = [];
        companies.forEach((element: any) => {
            const company = { label: element.company_name, value: element.id };
            companyData.push(company);
        });

        if (isInserted) {
            msg = message;
            messcolor = 'green'
        } else {
            msg = message;
            messcolor = 'red'
        }

        return (
            <div className="page">
                <CheckChanges path="/add-group" />
                <Topbar />
                <div className="page-content d-flex align-items-stretch">
                    <Sidebar />
                    <div className="content-inner">
                        {/* <!-- Page Header--> */}
                        <header className="page-header pb-1">
                            <div className="container-fluid">
                                <div className="d-flex align-items-center justify-content-between">
                                    <h4>Groups Management</h4>
                                </div>
                            </div>
                        </header>
                        {/*  Breadcrumb */}
                        <div className="breadcrumb-holder container-fluid">
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/groups" className="text-primary">Groups</Link></li>
                                <li className="breadcrumb-item active">Add Group</li>
                            </ul>
                        </div>
                        <section className="forms">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="card">
                                            <div className="card-body">
                                                <strong><p className="text-center font-weight-light mb-4" style={{ color: messcolor }}>
                                                    {msg}
                                                </p></strong>

                                                <div className="form-horizontal">

                                                    <div className="row form-group">
                                                        <label className="col-md-3 col-sm-3 form-control-label font-weight-bold">Name<span className="text-danger">*</span></label>
                                                        <div className="col-md-9 col-sm-9">
                                                            <input id="name" type="text" name="name" required data-msg="Please enter Name" className="input-material" onChange={this.handleInputChange} />
                                                        </div>
                                                    </div>

                                                    <div className="row form-group">
                                                        <label className="col-md-3 col-sm-3 form-control-label font-weight-bold">Company<span className="text-danger">*</span></label>
                                                        <div className="col-md-9 col-sm-9">
                                                            <Select
                                                                closeMenuOnSelect={true}
                                                                name="company"
                                                                options={companyData}
                                                                className="basic-multi-select"
                                                                classNamePrefix="select"
                                                                onChange={e => this.handleCompanyInputChange(e)}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="row form-group">
                                                        <label className="col-md-3 col-sm-3 form-control-label font-weight-bold">Stores<span className="text-danger">*</span></label>
                                                        <div className="col-md-9 col-sm-9">
                                                            <Select
                                                                isMulti
                                                                closeMenuOnSelect={false}
                                                                name="store"
                                                                options={storeData}
                                                                className="basic-multi-select"
                                                                classNamePrefix="select"
                                                                onChange={e => this.handleItemsInputChange(e)}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="row form-group">
                                                        <label className="col-md-3 col-sm-3 form-control-label font-weight-bold">Description<span className="text-danger">*</span></label>
                                                        <div className="col-md-9 col-sm-9">
                                                            <textarea id="description" name="description" required data-msg="Please enter Description" className="input-material" onChange={this.handleInputChange} ></textarea>
                                                        </div>
                                                    </div>

                                                    <div className="row form-group">
                                                        <label className="col-md-3 col-sm-3 form-control-label font-weight-bold">Territary<span className="text-danger">*</span></label>
                                                        <div className="col-md-9 col-sm-9">
                                                            <select name="territary" className="form-control text-capitalize mt-2" required data-msg="Please select status" onChange={this.handleInputChange}>
                                                                <option value={config.INACTIVE}>Disabled</option>
                                                                <option value={config.ACTIVE}>Enabled</option>
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className="row form-group">
                                                        <label className="col-md-3 col-sm-3 form-control-label font-weight-bold">Status<span className="text-danger">*</span></label>
                                                        <div className="col-md-9 col-sm-9">
                                                            <select name="status" className="form-control text-capitalize mt-2" required data-msg="Please select status" onChange={this.handleInputChange}>
                                                                <option value={config.ACTIVE}>Active</option>
                                                                <option value={config.INACTIVE}>Inactive</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="form-group float-right mt-3">
                                                    <button className='btn btn-primary' disabled={!this.isGroupReady()} onClick={this.handleSaveBtnClick}>Add Group</button>
                                                </div>
                                            </div>
                                        </div >
                                    </div>
                                </div>
                            </div>
                        </section>
                        <Footer />
                    </div>
                </div>
            </div>
        );
    }
}
const mapStateToProps = (state: any) => {
    return {
        stores: state.store?.storeList || [],
        companies: state.company?.companies || []
    }
}
const mapDispatchToProps = (dispatch: any) => {
    return {
        companyList: function () {
            dispatch(companyList())
        },
        storesList: function (id: any) {
            dispatch(storesList(id))
        },

        addGroup: function (data: any) {
            dispatch(addGroupStore(data));
        },
        logoutUser: function () {
            dispatch(logoutUser());
        },
        
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(AddGroup);